import React from 'react';
import { ArrowUpRight, FileText } from 'lucide-react';
import { Button } from './ui/button';
import SectionLabel from './SectionLabel';
import { goalVideo } from '../mock';
import { useI18n } from '../i18n/I18nContext';

export default function Goal() {
  const { t } = useI18n();
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 space-y-6">
            <SectionLabel>{t('goal.tag')}</SectionLabel>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
              {t('goal.title_a')} <br className="hidden md:block" />
              {t('goal.title_b')} <br className="hidden md:block" />
              <span className="text-gradient-green">{t('goal.title_c')}</span>
            </h2>
            <p className="text-slate-700 leading-relaxed max-w-2xl">{t('goal.desc')}</p>
            <div className="flex flex-wrap gap-3 pt-2">
              <a href="#kapcsolat">
                <Button className="btn-primary bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-xl h-11 px-5">
                  {t('common.contact')}<ArrowUpRight className="ml-1.5 h-4 w-4" />
                </Button>
              </a>
              <a href="https://www.salesshark.eu/_files/ugd/f901ad_04ff0b43477d4bd694d5f47108205188.pdf" target="_blank" rel="noreferrer">
                <Button variant="outline" className="rounded-xl h-11 px-5 bg-transparent border-blue-500/25 text-slate-700 hover:bg-blue-500/10 hover:text-slate-900 hover:border-blue-500/50">
                  <FileText className="mr-1.5 h-4 w-4" />{t('goal.brochure')}
                </Button>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="relative rounded-3xl overflow-hidden border border-blue-500/12">
              <video autoPlay loop muted defaultMuted playsInline webkit-playsinline="true" preload="auto" disableRemotePlayback className="w-full h-[520px] object-cover">
                <source src={goalVideo.webm} type="video/webm" />
                <source src={goalVideo.mp4} type="video/mp4" />
              </video>
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#ffffff] via-[#ffffff]/70 to-transparent" />
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-blue-500/10 mix-blend-overlay" />
              <div className="absolute inset-x-6 bottom-6 flex items-end justify-between">
                <div className="space-y-1">
                  <div className="text-[10px] tracking-[0.3em] text-blue-600">{t('goal.mission')}</div>
                  <div className="font-display text-xl font-semibold text-slate-900">{t('goal.mission_title')}</div>
                </div>
                <span className="h-2 w-2 rounded-full bg-blue-500 shadow-[0_0_18px_rgba(37,99,235,0.9)] relative pulse-ring" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
